import { AuthService } from '../user/auth.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { Contribution } from '../track/contribution';
import { Settings } from '../settings/settings';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Guest, Website } from '../website-builder/wedding';
import { GuestStateStore } from './guest.state.store';

@Injectable()
export class GuestsResolve implements Resolve<any> {

  constructor(
    private _state: GuestStateStore,    
    private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Website> {
   

    
    return this._state.getState().take(1).switchMap(state => {
     
      if (state) {
        return Observable.of(state.guests);
      } else {
        return Observable.of(null);
      }
    });


    

  }
}



// WEBPACK FOOTER //
// ./src/app/guest-list/guests.resolve.ts